import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoadingComponent } from './core/components/global-loading/global-loading.component';
import { ThemeService } from './core/services';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, GlobalLoadingComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor() {
    // Instantiate at bootstrap so the theme effect and the
    // prefers-color-scheme listener attach immediately, even on routes that
    // never read the theme. index.html already applied it before first paint;
    // this keeps it live for the rest of the session.
    inject(ThemeService);
  }
}
